<template>
  <svg :width="width" :height="height" ref="chart">
    <rect ref="rect" x="0" y="0" :height="height" />
  </svg>
</template>

<script>
import d3 from '@/assets/d3';

export default {
  props: ['width', 'height', 'barWidth'],
  mounted() {
    this.updateChart();
  },
  watch: {
    barWidth() {
      this.updateChart();
    },
  },
  methods: {
    updateChart() {
      d3.select(this.$refs.rect)
        .transition(500)
        .attr('width', this.barWidth);
    },
  },
};
</script>

<style scoped>

</style>
